module.exports = __webpack_public_path__ + "static/media/contact_us_banner.ebd11160.jpg";